import { useYoutubeScrapeVideos } from "@entities/discovery/lib/hooks/useYoutubeScrapeVideos";
import { IYoutubeScrapeResponseItem } from "@shared/lib/types/influencer";
import { useCallback, useEffect, useState } from "react";
import {
  DEFAULT_DATE_RANGE_PRESET,
  DEFAULT_MAX_RESULTS,
  DateRangePreset,
} from "./lib/constants";
import { getPublishedRange } from "./lib/getPublishedRange";

export function useAdvancedYoutubeSearch() {
  const { scrapeYoutubeVideos, data, isLoading } = useYoutubeScrapeVideos();
  const [keywords, setKeywords] = useState<string[]>([]);
  const [dateRangePreset, setDateRangePreset] = useState<DateRangePreset>(
    DEFAULT_DATE_RANGE_PRESET
  );
  const [maxResults, setMaxResults] = useState(DEFAULT_MAX_RESULTS);
  const [items, setItems] = useState<IYoutubeScrapeResponseItem[]>([]);

  useEffect(() => {
    if (!data?.data) {
      return;
    }
    setItems(data.data.items ?? []);
  }, [data]);

  const handleExtract = useCallback(() => {
    if (keywords.length === 0 || isLoading) {
      return;
    }

    const { publishedFrom, publishedTo } = getPublishedRange(dateRangePreset);

    scrapeYoutubeVideos({
      query: keywords,
      publishedFrom,
      publishedTo,
      maxResults,
    });
  }, [
    dateRangePreset,
    isLoading,
    keywords,
    maxResults,
    scrapeYoutubeVideos,
  ]);

  return {
    keywords,
    setKeywords,
    dateRangePreset,
    setDateRangePreset,
    maxResults,
    setMaxResults,
    items,
    isLoading,
    canExtract: keywords.length > 0 && !isLoading,
    handleExtract,
  };
}
